/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Cool_Whale_RideInputs */

const en_keen_cool_whale_ride = /** @type {(inputs: Keen_Cool_Whale_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow Login`)
};

const de_keen_cool_whale_ride = /** @type {(inputs: Keen_Cool_Whale_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login erlauben`)
};

/**
* | output |
* | --- |
* | "Allow Login" |
*
* @param {Keen_Cool_Whale_RideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_cool_whale_ride = /** @type {((inputs?: Keen_Cool_Whale_RideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Cool_Whale_RideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_cool_whale_ride(inputs)
	return de_keen_cool_whale_ride(inputs)
});